module.exports = __webpack_public_path__ + "img/big.e8e9ba45.jpg";